export enum Albo {
    ARCHITETTO,
    INGEGNERE,
    PERITO_EDILE,
    GEOMETRA
}